import { render, staticRenderFns } from "./OrderExcelTable.vue?vue&type=template&id=632a6d27&scoped=true"
import script from "./OrderExcelTable.vue?vue&type=script&lang=ts"
export * from "./OrderExcelTable.vue?vue&type=script&lang=ts"
import style0 from "./OrderExcelTable.vue?vue&type=style&index=0&id=632a6d27&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632a6d27",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/185/185admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('632a6d27')) {
      api.createRecord('632a6d27', component.options)
    } else {
      api.reload('632a6d27', component.options)
    }
    module.hot.accept("./OrderExcelTable.vue?vue&type=template&id=632a6d27&scoped=true", function () {
      api.rerender('632a6d27', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/components/OrderExcelTable.vue"
export default component.exports